module.exports = __webpack_public_path__ + "img/2.4757fc80.png";